module.exports = __webpack_public_path__ + "img/A02-20070073-001.e0b9f643.jpg";